<template class="FlagAlertDropdown">
    <AppHeaderDropdown right no-caret >
        <template slot="header">
            <i class="fa-duotone fa-flag text-primary"></i>
            <b-badge v-if="items.length" pill variant="danger">{{ items.length }}</b-badge>
        </template>
        <template slot="dropdown">
            <b-dropdown-header class="text-center">
                <strong>You have {{ items.length }} flags</strong>
            </b-dropdown-header>
            <b-dropdown-form v-for="(item, idx) in items" v-bind:key="idx">
                <i :class="'fa-regular ' + item.icon"></i>
                <div class="float-left">{{ item.flag_type.abbreviations }} Order: #{{ item.flaggable_id }}</div>

                <b-button v-if="!isDeleting(item.id)" class="float-right" @click="removeItem(item.id)" size="sm"><i class="fa-regular fa-times"></i></b-button>
                <i v-if="isDeleting(item.id)" class="float-right fa-regular fa-spin fa-spinner"></i>
            </b-dropdown-form>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue';
    import {
        SYNC_USER,
    } from '../store/actions';
    export default {
        name: 'HeaderDropdownFlags',
        components: {
            AppHeaderDropdown,
        },
        created () {
            this.$http.get('/users/flags?priority=1').then((payload) => {
                console.log(payload);
                this.items = payload.data.data;
            });
        },
        mounted () {
            //this.joinBroadcastChannel(); FIXME reactivate me once fixed
        },
        beforeDestroy () {
            //this.leaveBroadcastChannel(); FIXME reactivate me once fixed
        },
        data() {
            return {
                items: [],
                deleted: [],
                profileCached: null,
            };
        },
        methods: {
            removeItem(id) {
                this.deleted[id] = true;
                this.$http.post('/users/flags/', {id: id}).then((payload) => {
                    this.items = payload.data.data;
                });
            },
            isDeleting(id) {
                return !!this.deleted[id];
            },
            joinBroadcastChannel: function () {
                this.$store.dispatch(SYNC_USER, (profile) => {
                    console.info(String.fromCodePoint(0x1F514) + ' Joining App.Flag.Users.' + profile.id+ ' channel from HeaderDropdownFlags.');
                    this.profileCached = profile;
                    this.$echo.channel('App.Flag.Users.' + profile.id)
                        .listen('FlagWasCreated', this.flagUpdatedCall)
                        .listen('FlagWasUpdated', this.flagUpdatedCall)
                        .listen('FlagWasDeleted', this.flagUpdatedCall)
                        .error((e) => {
                            console.log('ERROR OCCURRED', e);
                        });
                });
            },
            leaveBroadcastChannel: function() {
                this.$echo.leaveChannel('App.Flag.Users.' + this.profileCached.id);
            },
            flagUpdateCall(payload) {
                let flag = payload.flag;
            }
        },
    };
</script>

<style>
    .FlagNotificationDropdown .dropdown-menu {
        width:250px !important;
        min-width:250px !important;
    }
    .FlagNotificationDropdown .b-dropdown-form {
        width:250px !important;
        min-width:250px !important;
        padding: 0;
     }
</style>